var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-radio-group',{class:_vm.className,attrs:{"row":""},on:{"change":_vm.addSources},model:{value:(_vm.sourceGroup),callback:function ($$v) {_vm.sourceGroup=$$v},expression:"sourceGroup"}},_vm._l((_vm.availableSources),function(source){return _c('v-radio',{key:source.id,class:{
        small: _vm.size === 'small',
        large: _vm.size === 'large',
      },attrs:{"label":source.display,"value":source.id}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }